<template>
  <div class="home">
    <header-bar></header-bar>
    <section class="main cl">
      <div class="main-left fl">
        <div class="content bg-white">
          <ul class="tab-bar cl">
            <li @click="tabClick(1)" :class="{ active: type == 1 }">推荐</li>
            <li @click="tabClick(0)" :class="{ active: type == 0 }">大河文学</li>
          </ul>
          <div
            class="news-list"
            v-infinite-scroll="getData"
            infinite-scroll-disabled="busy"
            infinite-scroll-distance="10"
          >
            <news-list
              v-for="(item, i) in articleDataList"
              :key="i"
              :dataList="item"
            ></news-list>
            <div v-if="dataLoadNomore" class="loading-all">没有更多数据</div>
            <div v-else :class="['loading',!userToken && type==3 ? 'loading-noicon':'']">{{!userToken && type==3 ? '请登录后查看' : '正在加载中，请稍等…'}}</div>
          </div>
        </div>
      </div>
      <div class="main-right fr">
        <div v-if="!userToken" class="bg-white pt10 pb10 mb10">
          <div class="login-box">
            <p>欢迎来到大河号</p>
            <p>登录开启更多精彩</p>
            <el-button type="danger" @click="loginBtn" round
              >立即登录</el-button
            >
          </div>
        </div>
        <div v-else class="user-info bg-white">
          <div class="pd12">
            <div
              class="base-info"
              @click="$router.push('/user/personal/' + userInfo.id)"
            >
              <img
                :src="
                  userInfo.icon ? userInfo.icon : '/static/img/mr-usericon.png'
                "
                alt=""
                class="user-avatar"
              />
              <span
                >{{ userInfo.userName }}<i class="el-icon-arrow-right"></i
              ></span>
            </div>
            <ul class="fans-count">
              <li>
                <p class="count">{{ userInfo.likeNum }}</p>
                <p>获赞</p>
              </li>
              <li class="fans" @click="toFansList">
                <p class="count">{{ userInfo.fansNum }}</p>
                <p>粉丝</p>
              </li>
              <li class="fans" @click="toAttentionList">
                <p class="count">{{ userInfo.attentionNum }}</p>
                <p>关注</p>
              </li>
            </ul>
            <ul class="add-type">
              <li @click="$router.push('/user/posts/add')">
                <img src="@/assets/images/img/add1.png" alt="" />
                <p>发文章</p>
              </li>
              <li @click="$router.push('/user/video/add')">
                <img src="@/assets/images/img/add2.png" alt="" />
                <p>发视频</p>
              </li>
            </ul>
          </div>
          <div class="user-others">
            <div class="others-sign">
              <el-button
                v-if="userInfo.signFlag == 0"
                type="danger"
                @click="signBtn"
                size="medium"
                round
                plain
                >签到</el-button
              >
              <el-button
                v-if="userInfo.signFlag == 1"
                type="danger"
                size="medium"
                disabled
                round
                plain
              >
                <i class="el-icon-check"></i>
                已签到</el-button
              >
            </div>
          </div>
        </div>
        <div class="bg-white mt10 sign-top10 pb10 mb10">
          <div class="sign-title mb10">签到热榜</div>
          <div class="sign-none" v-if="signHot.length==0">
            <h4>签到就送眼遇币</h4>
            <p>快去签到吧～</p>
          </div>
          <div v-else
            class="sign-item"
            v-for="(item, i) in signHot"
            :key="i"
            @click="userCenter(item.userId)"
          >
            <div class="item-user">
              <span v-if="i == 0" class="item-index top1">{{ i + 1 }}</span>
              <span v-else-if="i == 1" class="item-index top2">{{
                i + 1
              }}</span>
              <span v-else-if="i == 2" class="item-index top3">{{
                i + 1
              }}</span>
              <span v-else class="item-index">{{ i + 1 }}</span>
              <img
                :src="
                  item.userIcon ? item.userIcon : '/static/img/mr-usericon.png'
                "
                alt=""
              />
              <span>{{ item.userName }}</span>
            </div>
            <div class="item-time">{{ item.createTime }}</div>
          </div>
        </div>
        <com-foot></com-foot>
      </div>
    </section>
    <back-top></back-top>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import HeaderBar from "@/components/Header.vue";
import NewsList from "@/components/NewsList.vue";
import infiniteScroll from "vue-infinite-scroll";
import BackTop from "@/components/BackTop.vue";
import ComFoot from "@/components/ComFoot.vue";
export default {
  name: "Home",
  directives: { infiniteScroll },
  components: {
    HeaderBar,
    NewsList,
    BackTop,
    ComFoot
  },
  data() {
    return {
      userToken: localStorage.getItem("UserToken"),
      userInfo:
        localStorage.getItem("UserInfo") &&
        JSON.parse(localStorage.getItem("UserInfo")),
      dialogVisible: false,
      loginType: 0,
      phonenum: "",
      phonecode: "",
      username: "",
      password: "",
      checked: false,
      checkedAgree: false,
      type: 1,
      busy: false,
      dataLoadNomore: false,
      page: 1,
      size: 10,
      channelDataList: [],
      signHot: [],
      articleDataList: [],
      articleHotDataList: [],
      channelColor: [
        "channel-jd",
        "channel-zt",
        "channel-lt",
        "channel-pk",
        "channel-qy",
        "channel-js",
        "channel-lx",
        "channel-gy",
        "channel-sh",
        "",
        "channel-qm",
        "channel-hd",
      ],
      showItemClannel: false
    };
  },
  methods: {
    ...mapActions(["LOGIN", "GET_USERINFO"]),
    userCenter(id) {
      this.$router.push("/usercenter/" + id);
    },
    toList(i, n) {
      let routerJump = this.$router.resolve({ path: "/list/" + i + "/" + n });
			window.open(routerJump.href, '_blank');
      // this.$router.push("/list/" + i + "/" + n);
    },
    loginBtn() {
      this.$router.push("/login/");
    },
    toFansList() {
      this.$router.push("/user/personalfans");
    },
    toAttentionList() {
      this.$router.push("/user/personalfollow");
    },
    signBtn() {
      this.$api.userSign({}).then((res) => {
        this.userInfo.signFlag = 1;
        this.getUserInfo();
        this.$message.success("成功");
      });
    },
    // 请求用户信息
    getUserInfo() {
      this.GET_USERINFO()
        .then(() => {
          this.userInfo = JSON.parse(localStorage.getItem("UserInfo"));
        })
        .catch(() => {});
    },
    tabClick(num) {
      this.type = num;
      this.page = 1;
      this.articleDataList = [];
      this.dataLoadNomore = false;
      this.getData();
    },
    loginTabClick(type) {
      this.loginType = type;
    },
    getData() {
      this.busy = true;
      this.$api
        .articleList({
          topicId: this.type==0?115:'',
          channelId: 0,
          current: this.page,
          size: this.size,
          type: this.type,
        })
        .then((res) => {
          res.data.data.records.forEach((item, index) => {
            if (item.imgStr) {
              item.imgStr = item.imgStr.split(",");
            } else {
              item.imgStr = [];
            }
            for (let i = 0; i < this.channelDataList.length; i++) {
              if (item.channelId == this.channelDataList[i].id) {
                item.channelColor = this.channelDataList[i].channelColor;
              }
            }
          });
          this.articleDataList = this.articleDataList.concat(
            res.data.data.records
          );
          if (res.data.data.current < res.data.data.pages) {
            this.page += 1;
            this.busy = false;
            this.dataLoadNomore = false;
          } else {
            this.dataLoadNomore = true;
          }
        });
    },
    getChannelData() {
      this.$api
        .channelList({
          type: 2,
        })
        .then((res) => {
          res.data.data.forEach((item, index) => {
            item.channelColor = this.channelColor[index];
          });
          this.channelDataList = res.data.data;
          localStorage.setItem('channelData', JSON.stringify(res.data.data))
        });
    },
    getSignHotData() {
      this.$api.signHotList({}).then((res) => {
        this.signHot = res.data.data;
      });
    }
  },
  created() {
    this.getChannelData();
    this.getSignHotData();
    if(this.userToken) {
      this.getUserInfo();
    }
  },
  mounted() {
    window.addEventListener("storage", (e) => {
      // console.log("别的浏览器页签storage发生变化啦:", e)
      if (e.key == "UserToken") {
        this.userToken = e.newValue;
      } else if (e.key == "UserInfo") {
        this.userInfo = e.newValue && JSON.parse(e.newValue);
      }
    });
  },
};
</script>

<style scoped lang="scss">
.main {
  width: 1000px;
  margin: 0 auto;
  padding-top: 70px;
  .main-left {
    width: 680px;
    .channels {
      display: flex;
      justify-content: left;
      flex-flow: row wrap;
      padding: 14px 24px;
      li {
        width: 25%;
        text-align: center;
        padding: 14px 0;
        cursor: pointer;
        img {
          width: auto;
          height: 74px;
        }
        p {
          margin-top: -18px;
          font-size: 16px;
        }
        &:hover {
          background: #f6f6f6;
        }
      }
    }
    .tab-bar {
      line-height: 2.5;
      padding: 10px 24px 0;
      border-bottom: 1px solid #efefef;
      li {
        float: left;
        margin-right: 82px;
        font-size: 18px;
        cursor: pointer;
        &.active {
          font-weight: bolder;
          border-bottom: 4px solid #317DFF;
          border-radius: 2px;
          color: #317DFF;
        }
      }
    }
    .loading {
      width: 680px;
      height: 52px;
      background: url("../assets/images/loading-icon.png") no-repeat 238px
        center;
      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.07);
      font-size: 15px;
      font-weight: 400;
      color: #666666;
      border-top: 10px solid #f7f7f7;
      text-align: center;
      line-height: 42px;
    }
    .loading-noicon {
      background: none;
    }
    .loading-all {
      width: 680px;
      height: 52px;
      box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.07);
      font-size: 15px;
      font-weight: 400;
      color: #666666;
      border-top: 10px solid #f7f7f7;
      text-align: center;
      line-height: 42px;
    }
  }
  .main-right {
    width: 310px;
    .login-box {
      width: 286px;
      height: 189px;
      margin: 0 auto;
      text-align: center;
      padding-top: 40px;
      font-size: 16px;
      line-height: 1.5;
      color: #432c29;
      background: #fff url("../assets/images/login_bg.png") center no-repeat;
      button {
        margin-top: 20px;
        width: 160px;
        height: 40px;
        background: #317DFF;
      }
    }
    .user-info {
      .pd12 {
        padding: 12px;
      }
      .base-info {
        cursor: pointer;
        padding: 15px;
        img {
          width: 56px;
          height: 56px;
          border-radius: 50%;
          vertical-align: middle;
          margin-right: 12px;
        }
        span {
          font-size: 18px;
          color: #121212;
          i {
            color: #999999;
            margin-left: 7px;
            font-size: 12px;
          }
        }
      }
      .fans-count {
        display: flex;
        justify-content: space-around;
        padding: 14px 0;
        font-size: 16px;
        color: #666666;
        text-align: center;
        margin: 7px 0 12px;
        background: rgba(232, 233, 235, 0.3);
        border-radius: 4px;
        .fans {
          cursor: pointer;
        }
        .count {
          font-size: 18px;
          color: #317DFF;
          margin-bottom: 10px;
        }
      }
      .add-type {
        display: flex;
        justify-content: space-around;
        text-align: center;
        li {
          cursor: pointer;
        }
        img {
          margin-bottom: 5px;
        }
      }
      .user-others {
        margin-top: 8px;
        border-top: 1px solid #efefef;
        display: flex;
        justify-content: space-between;
        text-align: center;
        .others-sign {
          padding-top: 40px;
          width: 100%;
          height: 110px;
          border-right: 1px solid #efefef;
          p {
            color: #666666;
            font-size: 12px;
            margin-top: 10px;
            a {
              color: #666666;
              font-size: 12px;
            }
          }
          button {
            height: 34px;
            border: 1px solid #317DFF;
            background: #317DFF;
            color: #fff;
            width: 96px;
          }
        }
        .others-bi {
          padding-top: 15px;
          width: 50%;
          line-height: 24px;
          h3 {
            font-size: 21px;
            color: #317DFF;
          }
          p {
            font-size: 16px;
            span {
              font-size: 12px;
              color: #317DFF;
              i {
                font-weight: 600;
              }
            }
          }
        }
      }
    }
    .sign-top10 {
      .sign-title {
        color: #121212;
        font-size: 18px;
        font-weight: 600;
        padding: 18px 11px 18px 40px;
        background: url("../assets/images/icon/hot.png") center left 10px
          no-repeat;
        border-bottom: 1px solid #efefef;
      }
      .sign-none{
        padding: 25px 0;
        background: url("../assets/images/icon/coin.png") center left 67px no-repeat;
        text-indent: 127px;
        h4{
          color: #121212;
          line-height: 21px;
          font-size: 15px;
          font-weight: normal;
        }
        p{
          font-size: 14px;
          color: #666;
          line-height: 20px;
        }
      }
      .sign-item {
        padding: 8px 20px;
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .item-user {
          display: flex;
          justify-content: left;
          align-items: center;
          font-size: 15px;
          .item-index {
            border-radius: 2px;
            font-size: 14px;
            color: #333;
            width: 19px;
            height: 19px;
            text-align: center;
            line-height: 19px;
            &.top1 {
              background: #F23531;
              color: #fff;
            }
            &.top2 {
              background: #fb6f6c;
              color: #fff;
            }
            &.top3 {
              background: #f98537;
              color: #fff;
            }
          }
          img {
            width: 36px;
            height: 36px;
            border-radius: 50%;
            margin: 0 10px;
          }
        }
        .item-time {
          font-size: 13px;
          color: #8c8c8c;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue